import * as React from 'react';
import styled, { keyframes } from 'styled-components';
import { colors } from 'bench-style-constants';

const pulse = keyframes`
    0%, 100% {
        opacity: 1
    }
    50% {
        opacity: 0.5
    }
`;

const StyledSkeleton = styled.span<SkeletonProps>`
  display: inline-block;
  width: ${({ width }) => (width ? `${width}px` : '100%')};
  height: ${({ height }) => height}px;
  background: ${colors.silt};
  animation: ${pulse} 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
`;

type SkeletonProps = {
  width?: number;
  height: number;
};

export const Skeleton = ({ width, height }: SkeletonProps): React.ReactElement => {
  return <StyledSkeleton width={width} height={height} />;
};
